import { CollectionNewScrapsSnakeCase } from '../types';

import convertArticleItem from './convertArticleItem';

const convertCollectionScrapItem = (data: CollectionNewScrapsSnakeCase[]) => {
  return data.map((scrap) => {
    return {
      collectionTitle: scrap.collection_title,
      dateScrapped: scrap.date_scrapped,
      news: convertArticleItem([scrap.news])[0],
      profile: {
        id: scrap.profile.id,
        image: scrap.profile.image,
        name: scrap.profile.name,
        role: scrap.profile.role,
        roleKor: scrap.profile.role_kor,
      },
    };
  });
};

export default convertCollectionScrapItem;
